// App-wide share icon using the Material Symbols "ios_share" glyph.
export const ShareIcon = ({ className = "", size = 20 }) => (
  <span className={`material-symbols-outlined ${className}`} style={{ fontSize: size }} aria-hidden="true">
    ios_share
  </span>
);

export default ShareIcon;
